module.exports = __webpack_public_path__ + "static/media/file-csv-solid.d6369a99.svg";